$(document).on('click', '#form-cart-order .promocode-area .btn-activate', function () {
	let $btn = $(this);
	let $container = $(this).closest('.promocode-area');
	let $form = $(this).closest('#form-cart-order');
	let $input = $container.find('[name=promocode]');
	let code = $input.val();

	$input.removeClass('is-invalid');

	if (!code) {
		$input.addClass('is-invalid');
		return false;
	}

	let params = {
		_token: App.csrf,
		code: code,
		phone: $form.find('[name=user_phone]').val(),
	};

	let $msg = $container.find('.msg');
	$msg.removeClass('text-success text-danger').text('');

	$.post('/cart/promocode/check', params, function (data) {
		if (data.error) {
			$msg.addClass('text-danger').text(data.msg);
		} else {
			$msg.addClass('text-success').html(`
				<div>Промокод активирован</div>
				<div>Скидка: ${data.discount}</div>
			`);

			VegasCatalog.Order.updateTotals();

			$btn.removeClass('btn-activate').addClass('btn-deactivate');
		}
	});

	return false;
});

$(document).on('click', '#form-cart-order .promocode-area .btn-deactivate', function () {
	let $container = $(this).closest('.promocode-area');
	let $input = $container.find('[name=promocode]');
	let $msg = $container.find('.msg');

	$input.val('');
	$msg.text('');

	VegasCatalog.Order.updateTotals();

	$(this).removeClass('btn-deactivate').addClass('btn-activate');

	return false;
});
